module.exports = __webpack_public_path__ + "img/thinking_panda4.a264b937.gif";